import { ErrorHandler, Injectable, NgZone } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private ngZone: NgZone) {}

  handleError(error: any): void {
    const errorStr = (error?.message || error?.toString() || '').toLowerCase();

    // Check if error is caused by chunk/lazy-loading failure after a new deployment
    const isChunkError =
      errorStr.includes('loading chunk') ||
      errorStr.includes('loading css chunk') ||
      errorStr.includes('failed to fetch dynamically imported module') ||
      errorStr.includes('importing a module script failed') ||
      (errorStr.includes('unexpected token') && errorStr.includes('<'));

    if (isChunkError) {
      console.warn('[GlobalErrorHandler] ChunkLoadError detected (new deployment or missing chunk). Initiating auto-recovery reload...');

      // Prevent infinite reload loops (maximum 1 reload per 15 seconds)
      let lastReload = 0;
      try {
        if (typeof sessionStorage !== 'undefined') {
          lastReload = Number(sessionStorage.getItem('wp_chunk_reload_ts') || '0');
        }
      } catch {
        lastReload = 0;
      }

      const now = Date.now();
      if (now - lastReload > 15000) {
        try {
          if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('wp_chunk_reload_ts', now.toString());
          }
        } catch {}

        this.ngZone.runOutsideAngular(() => {
          // Hard reload from server to fetch the latest index.html and chunk bundles
          window.location.reload();
        });
        return;
      } else {
        console.error('[GlobalErrorHandler] Reload throttled to prevent loop. Raw error:', error);
      }
    }

    // Default logging for any other uncaught error
    console.error('[GlobalErrorHandler] Uncaught error:', error);
  }
}
